import React, { useState, useContext, useEffect } from "react";
import Axios from "axios";
// Own Components
import Banner from "../Components/Banner";
import StateContext from "../StateContext";
// React Router Components
import { Link, useHistory } from "react-router-dom";
// Mui Components
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackTwoToneIcon from "@material-ui/icons/ArrowBackTwoTone";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import clsx from "clsx";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { handleError } from "../Functions/getAlert";
import DispatchContext from "../DispatchContext";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  wrapper: {
    marginTop: "1.5rem",
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export const RegisterMd = () => {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [isLoading, setIsLoading] = useState(false);
  let [registered, setRegistered] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
    alertSuccess: false,
  });
  const [snack, setSnack] = useState({
    vertical: "top",
    horizontal: "center",
  });
  let history = useHistory();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });

  const [RegisterValues, setRegisterValues] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    dob: "",
    gender: "",
    mobile_no: "",
    password: "",
    confirmPassword: "",
  });
  const handleSubmit = (e) => {
    alert(e);
    e.preventDefault();
    setLoading(true);
    if (RegisterValues.firstName != "") {
      let emailValidation = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      if (!emailValidation.test(RegisterValues.email)) {
        setAlertMessage({
          open: true,
          message: "Email Format is not correct!",
          alertSuccess: false,
        });
        setLoading(false);
        return;
      }
      if (
        RegisterValues.mobile_no.length >= 7 &&
        RegisterValues.mobile_no.length < 15
      ) {
        if (RegisterValues.password === RegisterValues.confirmPassword) {
          Axios.post(
            `${process.env.REACT_APP_API_URL}login/customer-registration`,
            {
              firs: RegisterValues.name,
              email: RegisterValues.email,
              mobile_no: RegisterValues.mobile_no,
              password: RegisterValues.password,
            }
          )
            .then((response) => {
              if (response.status === 200) {
                setAlertMessage({
                  open: true,
                  message: "Your account has been created successfully!",
                  alertSuccess: true,
                });
                setLoading(false);
                setRegistered(true);
                window.location.reload();
              } else {
                setAlertMessage({
                  open: true,
                  message: `Something Went Wrong. Please Try Again`,
                  alertSuccess: false,
                });
                return;
              }
            })
            .catch((e) => {
              setLoading(false);
              handleError(e, appDispatch);
              // console.log(e)
              return;
            });
        } else {
          setLoading(false);
          setAlertMessage({
            open: true,
            message: `Password Didn't Match`,
            alertSuccess: false,
          });
          return;
        }
      } else {
        setLoading(false);
        setAlertMessage({
          open: true,
          message: "Please Enter Correct Mobile No",
          alertSuccess: false,
        });
        return;
      }
    } else {
      // setAlertMessage({
      //   open: true,
      //   message: "Please Fill All The Fields",
      //   alertSuccess: false,
      // });
      setLoading(false);
      return;
    }
  };
  const updateField = (e) => {
    setRegisterValues({
      ...RegisterValues,
      [e.target.name]: e.target.value,
    });
  };
  useEffect(() => {
    setTimeout(() => {
      setAlertMessage({ open: false, message: "", alertSuccess: false });
    }, 8000);
    if (registered) {
      setIsLoading(true);
      history.push(`/`);
    }
  }, [alertMessage.open]);
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertMessage.open}
        className={alertMessage.alertSuccess ? "success-alert" : "danger-alert"}
      >
        {alertMessage.alertSuccess ? (
          <Alert severity="success">{alertMessage.message}</Alert>
        ) : (
          <Alert severity="error">{alertMessage.message}</Alert>
        )}
      </Snackbar>
      <form action="" onSubmit={handleSubmit}>
        <div className="row m-0 justify-content-center">
          <div className="col-md-12 mt-2 px-1">
            <TextField
              id="register_fname"
              name="name"
              value={RegisterValues.name}
              onChange={updateField}
              type="text"
              className="w-100"
              label="First Name"
            />
          </div>
          <div className="col-md-12 mt-2 px-1">
            <TextField
              id="register_mname"
              name="mname"
              value={RegisterValues.name}
              onChange={updateField}
              type="text"
              className="w-100"
              label="Middle Name"
            />
          </div>
          <div className="col-md-12 mt-2 px-1">
            <TextField
              id="register_lname"
              name="lname"
              value={RegisterValues.name}
              onChange={updateField}
              type="text"
              className="w-100"
              label="Last Name"
            />
          </div>

          <div className="col-md-12 mt-2 px-1">
            <TextField
              id="register_email"
              name="email"
              value={RegisterValues.email}
              onChange={updateField}
              type="email"
              className="w-100"
              label="Email"
            />
          </div>
          <div className="col-md-12 mt-2 px-1">
            <TextField
              id="register_mobile_no"
              name="mobile_no"
              value={RegisterValues.mobile_no}
              onChange={updateField}
              type="number"
              className="w-100"
              label="Mobile No"
            />
          </div>
          <div className="col-md-12 mt-2 px-1">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                margin="normal"
                id="dob-field"
                label="Date Of Birth"
                name="dob"
                format={"yyyy-MM-dd"}
                value={RegisterValues.dob}
                className="w-100 m-0"
                onChange={updateField}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </div>
          <div className="col-md-12 mt-2 px-1">
            <TextField
              id="register_fname"
              name="name"
              value={RegisterValues.name}
              onChange={updateField}
              type="text"
              className="w-100"
              label="First Name"
            />
          </div>
          <div className="col-md-12 mt-2 px-1">
            <TextField
              id="register_password"
              name="password"
              value={RegisterValues.password}
              onChange={updateField}
              type="password"
              className="w-100"
              label="Password"
            />
            <div className="text-left">
              <p className="text-muted small">
                * Password should be 8 characters long
              </p>
            </div>
          </div>
          <div className="col-md-12 px-1">
            <TextField
              id="register_confirm_password"
              name="confirmPassword"
              value={RegisterValues.confirmPassword}
              onChange={updateField}
              type="password"
              className="w-100"
              label="Confirm Password"
            />
          </div>

          <div className="col-12 LoginButtonContainer text-center">
            <div className={classes.root}>
              <div className={classes.wrapper}>
                <Button
                  variant="contained"
                  type="submit"
                  className={`${buttonClassname} bg-primary login_btn mt-4`}
                >
                  {loading ? "Loading" : "Register"}
                </Button>
                {loading && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </div>
            {/* <div className="mt-3">
                                   <p className="small text-muted">Already have an account? <Link to={`/`} className="text-primary">Login</Link></p>
                              </div> */}
          </div>
        </div>
      </form>
    </>
  );
};
